import React from "react";
import {Box, Button, Container, Stack, Typography} from "@mui/material";
import {Link as RouterLink} from "react-router-dom";
import {useUserAuth} from "../../context/UserAuthContext";

/**
 * Barra superior comum aos portais (associações e engenheiros).
 * Adapta o título, os links e o nome de saudação ao papel da sessão.
 * "Sair" termina a sessão; a RoleRoute redireciona para a página inicial (/).
 */
const PortalTopbar = () => {

    const {profile, role, logOut} = useUserAuth();

    const isEngineer = role === "engineer";
    const base = isEngineer ? "/app/engenheiro" : "/app/associacao";
    const title = isEngineer ? "E4IU · Engenheiros" : "E4IU · Associações";

    const firstName = isEngineer
        ? (profile?.FirstName || "")
        : (profile?.Name ? profile.Name.split(" ")[0] : "");

    const navButton = {
        textTransform: "none",
        color: "#3E4F88",
        fontWeight: 600,
        "&:hover": {color: "#8B4513"},
    };

    return (
        <Box component="nav" sx={{borderBottom: 1, borderColor: "divider", bgcolor: "background.paper"}}>
            <Container maxWidth="lg">
                <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2} sx={{py: 1.5}}>
                    <Typography variant="h6" sx={{fontWeight: 700, color: "#3E4F88"}}>
                        {title}
                    </Typography>
                    <Stack direction="row" spacing={1}>
                        <Button component={RouterLink} to={base} variant="text" sx={navButton}>Projetos</Button>
                        <Button component={RouterLink} to={`${base}/perfil`} variant="text" sx={navButton}>
                            {firstName ? `Olá, ${firstName}` : "Perfil"}
                        </Button>
                        <Button onClick={() => logOut()} variant="text" color="inherit" sx={navButton}>Sair</Button>
                    </Stack>
                </Stack>
            </Container>
        </Box>
    );
};

export default PortalTopbar;
